import { isFavorite, isRead } from '../../../services/utils/leads';
import { multiSelectOptions } from '../../filterTable/filters';

import * as types from './types';
import {
  setData,
  selectedLead,
  updateLeads,
  updateTabSelected,
  deselectAllTabs,
  updateTabLastDate,
  updateTabLastNew,
  updateTabLastFalse,
  updateTabDisplay
} from './utils';

const initialState = {
  leads: [],
  paging: { total: 0, offset: 0, limit: 0 },
  tabs: [
    { key: 'email', isSelected: true, value: 1, track: 'Mensajes', last: '', new: false, display: true },
    { key: 'phoneCall', isSelected: false, value: 6, track: 'Vieron Teléfono', last: '', new: false, display: true },
    { key: 'whatsapp', isSelected: false, value: 10, track: 'Whatsapp', last: '', new: false, display: true },
    { key: 'otros', isSelected: false, value: 99, track: 'Otros', last: '', new: false, display: true }
  ],
  loading: false,
  error: false,
  updateMobile: false,
  snackBar: {},
  params: {
    contactPublisherUserId: undefined,
    limit: 20,
    offset: 0,
    actionType: multiSelectOptions.filter(option => option.tabFilter === 1),
    postingId: '',
    status: 'nondiscarded',
    sort: 'last_activity',
    textSearch: '',
    feedback: ''
  },

  paramsOther: {
    contactPublisherUserId: undefined,
    limit: 20,
    offset: 0,
    actionType: multiSelectOptions.filter(option => option.tabFilter === 99),
    postingId: '',
    status: 'nondiscarded',
    sort: 'last_activity'
  },

  paramsPhoneCall: {
    contactPublisherUserId: undefined,
    limit: 20,
    offset: 0,
    actionType: multiSelectOptions.filter(option => option.tabFilter === 6),
    postingId: '',
    status: 'nondiscarded',
    sort: 'last_activity'
  },
  paramsWhatsapp: {
    contactPublisherUserId: undefined,
    limit: 20,
    offset: 0,
    actionType: multiSelectOptions.filter(option => option.tabFilter === 10),
    postingId: '',
    status: 'nondiscarded',
    sort: 'last_activity'
  },

  paramsEmails: {
    contactPublisherUserId: undefined,
    limit: 20,
    offset: 0,
    actionType: multiSelectOptions.filter(option => option.tabFilter === 1),
    postingId: '',
    status: 'nondiscarded',
    sort: 'last_activity'
  },

  previousFilters: '',
  notShowLoading: false,
  leadStatus: [],
  leadStatusError: false,
  infoPublisher: [],
  leadsOther: [],
  leadsPhoneCall: [],
  leadsWhatsapp: [],
  leadsEmails: []
};

function tableReducer(state = initialState, action) {
  switch (action.type) {
    case types.NOT_SHOW_LOADING:
      return {
        ...state,
        notShowLoading: action.payload
      };
    case types.FETCH_LEADS_MOBILE:
      return {
        ...state,
        loading: true,
        error: false,
        params: { ...state.params, ...action.payload }
      };
    case types.FETCH_LEADS_MOBILE_SUCCEEDED:
      state.loading = false;
      state.error = false;
      if (action.payload.result) {
        if (state.updateMobile === true && action.payload.result.length >= 20) {
          state.params.offset += 20;
          state.updateMobile = false;
        }
        state.contactPublisherUserId = action.payload.result.contact_publisher_user_id;
        state.paging = action.payload.paging;
        const newData = [];
        action.payload.result.forEach(d => {
          const found = state.leads.find(f => f.id === d.id);
          if (found === undefined) {
            d.isSelected = false;
            d.isRead = isRead(d.statuses);
            d.isFavorite = isFavorite(d.statuses);
            newData.push(d);
          }
        });
        state.leads = [...state.leads, ...newData];
      }
      state.updateMobile = false;
      return { ...state };
    case types.FETCH_LEADS:
      return {
        ...state,
        loading: !state.notShowLoading,
        notShowLoading: false,
        error: false,
        params: { ...state.params, ...action.payload }
      };
    case types.FETCH_LEADS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        error: false,
        leads: setData(action.payload.result),
        paging: action.payload.paging
      };

    case types.FETCH_LEADS_SUCCEEDED_OTHER:
      return {
        ...state,
        leadsOther: setData(action.payload.result || [])
      };

    case types.FETCH_LEADS_SUCCEEDED_PHONECALL:
      return {
        ...state,
        leadsPhoneCall: setData(action.payload.result || [])
      };

    case types.FETCH_LEADS_SUCCEEDED_WH:
      return {
        ...state,
        leadsWhatsapp: setData(action.payload.result || [])
      };

    case types.FETCH_LEADS_SUCCEEDED_EMAIL:
      return {
        ...state,
        leadsEmails: setData(action.payload.result || [])
      };

    case types.FETCH_LEADS_FAILED:
      return { ...state, loading: false, error: true, leads: setData([]) };

    case types.FETCH_LEADS_MOBILE_SUCCEEDED_UPDATE_EVENT:
      return { ...state, loading: false, error: false, updateMobile: true };

    case types.UPDATE_LEAD_STATUS_FAVORITE_SUCCEEDED:
      return {
        ...state,
        leads: state.leads.map(l => {
          if (l.contact_publisher_user_id === action.payload.contact_publisher_user_id) {
            l.statuses = l.statuses.filter(
              status => status !== (action.payload.isFavorite ? 'FAVORITE' : 'NONFAVORITE')
            );
            l.statuses.push(action.payload.isFavorite ? 'NONFAVORITE' : 'FAVORITE');
            l.isFavorite = isFavorite(l.statuses);
          }
          return l;
        })
      };
    case types.UPDATE_LEAD_STATUS_FAVORITE_FAILED:
      return { ...state, leads: selectedLead(action.payload, state.leads) };
    case types.SHOW_SNACKBAR:
      return {
        ...state,
        snackBar: action.payload
      };
    case types.HIDE_SNACKBAR:
      return {
        ...state,
        snackBar: { ...state.snackBar, show: false }
      };
    case types.UPDATE_LEAD_STATUS_SUCCEEDED:
      updateLeads(action.payload.contactIds, action.payload.leadStatus)(state.leads, state.paging);
      return { ...state };
    case types.CHANGE_PAGE:
      return {
        ...state,
        params: { ...state.params, offset: action.payload }
      };

    case types.CHANGE_TAB_OPTION:
      state.tabs = updateTabSelected(action.payload)(state.tabs);
      return { ...state };

    case types.UPDATE_TAB_OPTION:
      state.tabs = updateTabLastDate(action.payload, state.tabs);
      return { ...state };

    case types.UPDATE_TAB_NEW:
      state.tabs = updateTabLastNew(action.payload, state.tabs);
      return { ...state };

    case types.UPDATE_TAB_NEW_FALSE:
      state.tabs = updateTabLastFalse(action.payload, state.tabs);
      return { ...state };

    case types.RESET_TAB_OPTION:
      state.tabs = deselectAllTabs(state.tabs);
      return { ...state };

    case types.UPDATE_TAB_DISPLAY:
      state.tabs = updateTabDisplay(action.payload, state.tabs);
      return { ...state };

    case types.FETCH_LEADS_STATUS:
      state.leadStatus = action.payload;
      return { ...state };

    case types.FECTH_LEAD_UPDATE_STATUS_FAILED:
      state.leadStatusError = true;
      return { ...state };

    case types.FETCH_LEADS_STATUS_SUCCEEDED:
      state.leadStatusError = false;
      return { ...state };

    case types.FETCH_PUBLISHER_SUCCEEDED:
      state.infoPublisher = action.payload;
      return { ...state };

    case types.CHANGE_FILTER:
      return {
        ...state,
        params: {
          ...state.params,
          feedback: state.params.feedback
        }
      };

    default:
      return { ...state };
  }
}

export { tableReducer };
